import { ProgressIndicator } from '@oneaudi/unified-web-components';
import React from 'react';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  background-color: ${({ theme }) =>
    theme.type === 'legacy'
      ? 'var(--one-header-color-white)'
      : 'var(--one-header-color-canvas-default)'};
  display: flex;
  align-items: center;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: 100%;
  margin: 12px 0;
  z-index: 5;
`;

const AudiSearchFeatureAppLoader: React.FC = () => {
  return (
    <LoaderContainer>
      <ProgressIndicator
        aria-label="Loading Indicator"
        data-testid="progress-indicator"
        size="lg"
        type="infinite"
        variant="spinner"
        colorScheme="colored"
      />
    </LoaderContainer>
  );
};

export default AudiSearchFeatureAppLoader;
